module.exports = __webpack_public_path__ + "files/60f905e9a22a53949654df11e50a9428.svg";